import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-xxl-5" }
const _hoisted_2 = { class: "d-flex justify-content-center" }
const _hoisted_3 = { class: "col col-xxl-8" }
const _hoisted_4 = { class: "text-primary d-flex align-items-center mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-3 me-2" }, "help", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "contact me-3 pe-4 border-end" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 fs-5 text-primary me-2" }, "mail"),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@digital-pharma.be" }, "support@digital-pharma.be")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 fs-5 text-primary me-2" }, "call"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "me-2",
      href: "tel:+3289500019"
    }, "+32 89 50 00 19"),
    /*#__PURE__*/_createTextVNode("(ma - vr 9u00 - 17u00) ")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Digital Pharma"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Slingerweg 52"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 3600 - Genk")
  ])
], -1)
const _hoisted_8 = { class: "text-primary d-flex align-items-center mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-3 me-2" }, "sms", -1)
const _hoisted_10 = { class: "text-primary d-flex align-items-center mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-3 me-2" }, "vaccines", -1)
const _hoisted_12 = { class: "text-primary d-flex align-items-center mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-3 me-2" }, "inventory", -1)
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "text-primary fs-7 fw-bolder m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_card_header = _resolveComponent("base-card-header")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_Dashboard = _resolveComponent("Dashboard")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { "position-center": "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_base_card, { class: "help mb-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_base_card_header, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_4, [
                      _hoisted_5,
                      _createTextVNode(_toDisplayString(_ctx.$t('needHelp')) + "? ", 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_card_body, { class: "d-flex flex-row justify-content-start" }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            ($options.AbilityContext.isAuthorizedForFeature('ORDER_SMS_COMMUNICATION'))
              ? (_openBlock(), _createBlock(_component_base_card, {
                  key: 0,
                  class: "dashboard-sms mb-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_card_header, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_8, [
                          _hoisted_9,
                          _createTextVNode(_toDisplayString(_ctx.$t('smsConsumption')), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_base_card_body, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Dashboard, { "dashboard-type-code": "SMS_CREDITS" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($options.AbilityContext.isAuthorizedForFeature('ORCA'))
              ? (_openBlock(), _createBlock(_component_base_card, {
                  key: 1,
                  class: "dashboard-orca mb-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_card_header, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_10, [
                          _hoisted_11,
                          _createTextVNode(_toDisplayString(_ctx.$t('reservationsForReservationCampaigns')), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_base_card_body, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Dashboard, { "dashboard-type-code": "ORCA_RESERVATIONS" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_base_card, { class: "licences mb-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_base_card_header, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_12, [
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_ctx.$t('myLicenses')), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_card_body, null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.licences, (licence) => {
                        return (_openBlock(), _createElementBlock("li", { key: licence }, _toDisplayString(licence), 1))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_base_card, { class: "env" }, {
              default: _withCtx(() => [
                _createVNode(_component_base_card_body, null, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(this.appVersion) + " - " + _toDisplayString(this.config.environment) + " - " + _toDisplayString(this.config.buildtime), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}